<template>
  <!-- 库存转移-详情 -->
  <div class="detail-container">
    <detailHeader />

    <Head />
    <div class="detail ">
      <div class="body">
        <div class="tabs">
          <el-tabs v-model="status" type="card" @tab-click="handleClick">
            <!-- 未完成 -->
            <el-tab-pane :label="`${$t('message.uncompleted')}(${detail.pack_not_complete_count})`"
              name="0"></el-tab-pane>
            <!--  已完成 -->
            <el-tab-pane :label="`${$t('message.completed')}(${detail.pack_complete_count})`" name="1"></el-tab-pane>
            <!-- 全部 -->
            <el-tab-pane :label="`${$t('message.all')}(${list.length})`" name="2"></el-tab-pane>
          </el-tabs>
          <!-- 开始装箱 -->
          <el-button type="success" @click="startPacking"> {{ detail.status == 0 ? $t("message.startPacking")
            : detail.status_name }}</el-button>

        </div>
        <div class="table">
          <ol>
            <li class="flex05">
              <el-checkbox v-model="checked" @change="handleCheckedChange"></el-checkbox>
            </li>
            <li class="flex05">NO</li>
            <!-- 库位 -->
            <li class="flex2">{{ $t("message.location") }}</li>
            <!-- 订单编号 -->
            <li class="flex2">{{ $t("message.orderNumber") }}</li>
            <!-- 番号 -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!-- 图片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 商品属性 -->
            <li class="flex2">{{ $t("message.commodityAttribute") }}</li>
            <!-- 交易号/物流号 -->
            <li class="flex2">{{ $t("message.transactionNumberLogisticsNumber") }}</li>
            <!-- 单番操作备注 -->
            <li>{{ $t("message.operationProductRemark") }}</li>
            <!-- 已装箱数 -->
            <li>{{ $t("message.packedQuantity") }}</li>
            <!-- 转库数量 -->
            <li class="transferQuantity">{{ $t("message.transferQuantity") }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">
              <el-checkbox v-model="item.checked" @change="checkedChange"></el-checkbox>
            </li>
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 库位 -->
            <li class="flex2">
              <p>{{ item.grid_number.split("】-")[0] }}】-</p>
              <p style="color: #fa5058">
                {{ item.grid_number.split("】-")[1] }}
              </p>
            </li>
            <!-- 订单编号 -->
            <li class="flex2">
              <div>
                <router-link :to="'orderPaymentDetail/?order_sn=' + item.order_sn" target="_blank">
                  {{ item.order_sn }}
                </router-link>
                <p style="text-align: center;"> <el-link type="primary">{{ item.user.realname }}</el-link></p>
              </div>
            </li>
            <!-- 番号 -->
            <li class="flex05">{{ item.sorting }}</li>
            <!-- 图片 -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <el-image :src="item.pic" fit="fill" style="width: 300px; height: 300px;" />
                <a :href="item.link.goods_url" target="_blank" slot="reference">
                  <el-image :src="item.pic" fit="fill" style="width: 60px; height: 60px;" />
                </a>
              </el-popover>
            </li>
            <!-- 商品属性 -->
            <li class="flex2">
              <div class="template">
                <p v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </p>
              </div>
            </li>
            <!-- 交易号/物流号 -->
            <li class="flex2">
              <div class="template">
                <p>JY：{{ item.purchase_no }}</p>
                <p v-for="(itemDetail, itemIndex) in item.express_no
                 " :key="itemIndex">
                  WL{{ itemIndex + 1 }}：{{ itemDetail }}
                </p>
              </div>
            </li>
            <!-- 单番操作备注 -->
            <li>{{ item.remark }}</li>
            <!-- 已装箱数 -->
            <li>{{ item.box_num }}</li>
            <!-- 转库数量 -->
            <li class="transferQuantity">{{ item.num }}</li>
          </ul>
        </div>
      </div>
      <!-- 操作 -->
      <div class="operation" v-if="detail.status == 1">
        <div class="left">
          <!-- 全选 -->
          <el-checkbox v-model="checked" @change="handleCheckedChange"> {{ $t("message.allChecked")
          }}</el-checkbox>
          <!-- 装箱 -->
          <el-button type="primary" style="margin-left: 34px;" @click="intoBoxPreview"> {{ $t("message.encasement")
          }}</el-button>
          <!-- 取消装箱 -->
          <el-button type="primary" class="dark" @click="unpack"> {{ $t("message.unpack") }}</el-button>
          <!-- 添加箱子 -->
          <el-button type="success" @click="addBox"> {{ $t("message.addBox") }}</el-button>
          <!-- 删除箱子 -->
          <el-button type="primary" class="dark" @click="delBox"> {{ $t("message.delBox")
          }}</el-button>
          <!-- 修改箱规 -->
          <el-button type="primary" style="margin-right: 325px;" @click="modifyBoxRules">
            {{ $t("message.modifyBoxRules") }}
          </el-button>
          <!-- 装箱完了 -->
          <el-button type="primary" class="primary" @click="finishPacking">
            {{ $t("message.finishPacking") }}
          </el-button>
          <!-- 装箱完了取消 -->
          <el-button type="primary" class="dark" @click="cancelFinishPacking">
            {{ $t("message.finishPackingCancel") }}
          </el-button>
        </div>
        <div class="right">
          <!-- 箱子唛头打印 -->
          <el-button type="primary" class="primary" @click="printBoxLabel">
            {{ $t("message.printBoxLabel") }}
          </el-button>
          <!-- 装箱完成提交给行政 -->
          <el-button type="success" @click="submitToAdmin">
            {{ $t("message.submitToAdmin") }}
          </el-button>
        </div>
      </div>
      <div class="operation" v-if="detail.status == 2">
        <div class="left"></div>
        <div class="right">
          <!-- 箱子唛头打印 -->
          <el-button type="primary" class="primary" @click="printBoxLabel">
            {{ $t("message.printBoxLabel") }}
          </el-button>
        </div>
      </div>
      <!-- 箱子列表 -->
      <boxList ref="boxList" />
      <!-- 备注 -->
      <div class="remark">
        <!-- 整单操作备注： -->
        <div class="label"> {{ $t("message.entireOrderOperationRemark") }}</div>
        <el-input v-model="detail.remark" type="textarea" resize="none" readonly></el-input>
      </div>
    </div>
    <!-- 添加箱子 -->
    <addBox ref="addBox" :move_sn="move_sn" />
    <!-- 修改箱规 -->
    <modifyBoxRules ref="modifyBoxRules" :move_sn="move_sn" />
    <!-- 装箱 -->
    <encasement ref="encasement" :move_sn="move_sn" />
    <!-- 取消装箱 -->
    <cancelEncasement ref="cancelEncasement" />
    <!-- 转库唛头打印 -->
    <div v-show="false">
      <transferOrderLabel ref="transferOrderLabel" :printData="printData" />
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import detailHeader from '@/components/header/detailHeader.vue'
import Head from './components/head.vue'
import boxList from './components/boxList.vue'
import addBox from './components/addBox.vue'
import modifyBoxRules from './components/modifyBoxRules.vue'
import encasement from './components/encasement.vue'
import cancelEncasement from './components/cancelEncasement.vue'
import transferOrderLabel from './components/transferOrderLabel.vue'
export default {
  components: {
    detailHeader,
    Head,
    boxList,
    addBox,
    modifyBoxRules,
    encasement,
    cancelEncasement,
    transferOrderLabel
  },
  data() {
    return {
      move_sn: this.$route.query.move_sn,
      checked: false,
      tableData: [],
      status: '2',
      printData: [{}]
    }
  },
  computed: {
    ...mapState({
      detail: state => state.transferOrderDetail.detail,
      list: state => state.transferOrderDetail.detail.list || [],
      // 库存转移-箱子列表
      boxList: state => state.transferOrderDetail.boxList || [],
    }),
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.handleClick()
      },
      deep: true
    }
  },
  methods: {
    // 库存转移-开始装箱
    startPacking() {
      if (this.detail.status != 0) {
        return
      }
      this.$confirm('确定开始装箱吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.inventoryTransferApi.startPacking({
          move_sn: this.move_sn,
        }).then(res => {
          this.$message.success(res.msg)
          this.$store.dispatch('moveDetail', { move_sn: this.move_sn })
        })
      })
    },
    // 库存转移-全选/取消全选
    handleCheckedChange() {
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
      this.$forceUpdate()
    },
    // 库存转移-选中/取消选中
    checkedChange() {
      this.checked = this.tableData.every(item => item.checked)
      this.$forceUpdate()
    },
    // 库存转移-切换tab
    handleClick() {
      if (this.status == '0') {
        this.tableData = this.list.filter(item => (item.num - item.box_num) > 0)
      } else if (this.status == '1') {
        this.tableData = this.list.filter(item => item.box_num > 0)
      } else {
        this.tableData = JSON.parse(JSON.stringify(this.list))
      }
    },
    // 库存转移-添加箱子
    addBox() {
      this.$refs.addBox.init()
      this.$refs.addBox.dialogVisible = true
    },
    // 库存转移-删除箱子
    delBox() {
      let ids = this.getBoxId()
      if (ids.length == 0) {
        this.$message.warning('请选择要删除的箱子')
        return
      }
      this.$confirm('确定删除选中的箱子吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.inventoryTransferApi.deleteBox({
          ids,
        }).then(res => {
          this.$message.success(res.msg)
          this.$store.dispatch('transferOrdeBoxList', { move_sn: this.move_sn })
        })
      })
    },
    // 库存转移-修改箱规
    modifyBoxRules() {
      let ids = this.getBoxId()
      if (ids.length == 0) {
        this.$message.warning('请选择要修改箱规的箱子')
        return
      }
      this.$refs.modifyBoxRules.init(ids, this.boxList)
      this.$refs.modifyBoxRules.dialogVisible = true
    },
    // 库存转移-获取选中的箱子id
    getBoxId() {
      let ids = []
      this.boxList.forEach(item => {
        item.list.forEach(item => {
          if (item.checked) {
            ids.push(item.id)
          }
        })
      })
      return ids
    },
    // 库存转移-装箱完成提交给行政
    finishPacking() {
      let ids = this.getBoxId()
      if (ids.length == 0) {
        this.$message.warning('请选择要装箱完成的箱子')
        return
      }
      this.$confirm('确定装箱完成选中的箱子吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.inventoryTransferApi.batchCompleteBox({
          ids,
        }).then(res => {
          this.$message.success(res.msg)
          this.$store.dispatch('transferOrdeBoxList', { move_sn: this.move_sn })
        })
      })
    },
    // 库存转移-装箱完成取消
    cancelFinishPacking() {
      let ids = this.getBoxId()
      if (ids.length == 0) {
        this.$message.warning('请选择要取消装箱完成的箱子')
        return
      }
      this.$confirm('确定取消装箱完成选中的箱子吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.inventoryTransferApi.batchUncompleteBox({
          ids,
        }).then(res => {
          this.$message.success(res.msg)
          this.$store.dispatch('transferOrdeBoxList', { move_sn: this.move_sn })
        })
      })
    },
    // 库存转移-装箱完成提交给行政
    submitToAdmin() {
      this.$confirm('确定提交给行政吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.inventoryTransferApi.completePacking({
          move_sn: this.move_sn,
        }).then(res => {
          this.$message.success(res.msg)
          this.$store.dispatch('moveDetail', { move_sn: this.move_sn })
        })
      })
    },
    // 库存转移-装箱预览
    intoBoxPreview() {
      let move_detail_ids = this.tableData.filter(item => item.checked).map(item => item.id)
      let box_id_set = this.getBoxId()
      if (move_detail_ids.length == 0) {
        this.$message.warning('请选择要装箱预览的商品')
        return
      }
      if (box_id_set.length == 0) {
        this.$message.warning('请选择要装箱预览的箱子')
        return
      }
      this.$refs.encasement.intoBoxPreview(this.move_sn, move_detail_ids, box_id_set)
      this.$refs.encasement.dialogVisible = true
    },
    // 库存转移-取消装箱
    unpack() {
      let ids = this.getBoxId()
      if (ids.length == 0) {
        this.$message.warning('请选择要取消装箱的箱子')
        return
      }
      if (ids.length > 1) {
        this.$message.warning('只能选择一个箱子进行取消装箱')
        return
      }
      this.$refs.cancelEncasement.box_id = ids[0]
      this.$refs.cancelEncasement.move_sn = this.move_sn
      this.$refs.cancelEncasement.dialogVisible = true
      this.$refs.cancelEncasement.getBoxDetail()
    },
    // 库存转移-打印箱子唛头
    printBoxLabel() {
      this.printData = []
      this.boxList.forEach(item => {
        item.checked = false
        item.list.forEach(item => {
          if (item.checked) {
            this.printData.push({
              realname: this.detail.user?.realname,
              p_admin_realname: this.detail.user?.p_admin?.realname || '-',
              y_admin_realname: this.detail.user?.y_admin?.realname || '-',
              weight: item.weight,
              attr: item.attr,
              box_no: item.box_no,
              move_sn: this.move_sn,
            })
          }
        })
      })
      if (this.printData.length == 0) {
        this.$message.warning('请选择要打印箱子唛头的箱子')
        return
      }
      this.$nextTick(() => {
        this.$print(this.$refs.transferOrderLabel);
      });
    },
  },
  created() {
    this.$store.dispatch('moveDetail', {
      move_sn: this.move_sn,
    })

  },
}
</script>
<style scoped lang="scss">
.detail {
  margin: 24px;
  min-width: 1872px;
  position: relative;

  .tabs {
    position: relative;

    .el-button {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .table {
    ol {
      height: 50px;
      background-color: #EDEFF4;
      position: sticky;
      top: 0;
      left: 0;
      z-index: 100;
    }

    ul {
      padding: 0;
      background-color: #fff;

      li {
        padding: 20px 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;

      a {
        color: #B4272D;
      }
    }

    .transferQuantity {
      background-color: #DDECFF;
    }
  }

  /deep/.el-checkbox__inner {
    transform: scale(1.8);
  }

  .operation {
    position: sticky;
    bottom: 0;
    left: 0;
    padding: 24px;
    background-color: #F8F8F8;
    margin: 24px 0;
    border-radius: 8px;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
  }

  .remark {
    padding: 24px;
    background-color: #F8F8F8;
    display: flex;
    border-radius: 8px;

    .label {
      margin-right: 10px;
      width: 100px;
    }

    /deep/.el-textarea__inner {
      height: 200px;
      width: 1000px;
      resize: none;
      background-color: #F0F0F0;
    }
  }
}
</style>
